import { generatePath } from 'react-router';
import { request } from '@lib/request';
import { FetchPaymentStatusParamsDto } from '@api/payment-status/payment-status.dto';

const FETCH_PAYMENT_STATUS = '/sbp/v1/qr/:qrId/payment-status';

export const fetchPaymentStatus = async ({ qrId }: FetchPaymentStatusParamsDto) => {
    const result = await request.get<string>(generatePath(FETCH_PAYMENT_STATUS, { qrId }));
    return result.data;
};
